import React from 'react';
import { StarIcon } from 'lucide-react';
type StarRatingProps = {
  rating?: number;
  className?: string;
};
export function StarRating({
  rating = 5,
  className = 'h-4 w-4'
}: StarRatingProps) {
  return <span className="flex items-center gap-0.5" role="img" aria-label={`${rating} out of 5 stars`} data-id="element-351" data-mp="3kcizw2hr283u">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${className} ${i < rating ? 'fill-star text-star' : 'text-white/30'}`} aria-hidden="true" data-id="element-352" data-mp="3p5c2oktnr6da" data-mpi={i} />)}
    </span>;
}